// extracted by mini-css-extract-plugin
module.exports = {"header":"header__1-bvX","title":"title__I5H4F"};